import { useState } from "react";
import Config from "../../Config";
import Parents from "./Parents";
import Emps from "./Emps";
import Cards from "./Cards";
import Pickup from "./Pickup";

function AccessView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }

    
    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
 
 

    if(props.mainView.viewSelected == "parents") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "emps") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "cards") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "persons") tab4 = tab4 + " selected";
 
 
    

    var subMenu = <div className="submenu">
            <div className={tab1} module="access" view="parents" id="" onClick={props.mainView.quickGo} >Rodzice</div>
            <div className={tab2} module="access" view="emps" id="" onClick={props.mainView.quickGo} >Pracownicy</div>
            <div className={tab3}  module="access" view="cards" id="" onClick={props.mainView.quickGo} >Karty zbliżeniowe</div> 
            <div className={tab4}  module="access" view="persons" id="" onClick={props.mainView.quickGo} >Odbiór dzieci</div> 
    </div>



    if(props.mainView.viewSelected == 'parents' || props.mainView.viewSelected == undefined )
        {
            document.title ="Rodzice / Dostępy i uprawnienia"; 
            return (
                <div className="econtent ">                           
                                {subMenu}                            
                      <Parents  userData={props.userData}  mainView={props.mainView}  /> 
                 </div>
            )
        }


        if(props.mainView.viewSelected == 'emps'   )
            {
                document.title ="Pracownicy / Dostępy i uprawnienia"; 
                return (
                    <div className="econtent ">                           
                              {subMenu}                                  
                          <Emps  userData={props.userData}  mainView={props.mainView}  /> 
                     </div>
                )
            }


            if(props.mainView.viewSelected == 'cards'   )
                {
                    document.title ="Karty / Dostępy i uprawnienia"; 
                    return (
                        <div className="econtent ">                           
                               {subMenu}                                     
                              <Cards  userData={props.userData}  mainView={props.mainView}  /> 
                         </div>
                    )
                }    
                
            if(props.mainView.viewSelected == 'persons'   )
                {
                    document.title ="Odbiór dzieci"; 
                    return (
                        <div className="econtent ">                           
                               {subMenu}                                     
                              <Pickup  userData={props.userData}  mainView={props.mainView}  /> 
                         </div>
                    )
                } 



    return (
        <div className="econtent ">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );

}


export default AccessView